// extracted by mini-css-extract-plugin
module.exports = {"cardSocial":"styles_cardSocial__24nzI","bookmark":"styles_bookmark__3hbKE","likes":"styles_likes__3R2lU"};